import PlatformLight from '@/domain/scene/lights/generic/PlatformLight.js'

const LIGHT_P5_ELEM_NAME = 'LightP5'
const LIGHT_P5_INIT_X_REL = 0.10
const LIGHT_P5_CLOCK_POS = -40

export default class LightP5 extends PlatformLight {
  constructor () {
    super(
      LIGHT_P5_ELEM_NAME,
      LIGHT_P5_INIT_X_REL,
      LIGHT_P5_CLOCK_POS
    )
  }
}
